/**
 * IC EDIT (Claude): Branded search redirects
 * If a search query EXACTLY matches a known brand term, jump straight to that
 * collection instead of showing the generic search results page.
 * - Intercepts the search form submit (capture phase) so there is no flash.
 * - Also catches direct loads of /search?q=brand (e.g. from external links).
 * Exact-match only, so multi-word queries like "funko pop stand" are unaffected.
 * To add a term: add a "normalised term": "/collections/handle" pair below.
 */
(function () {
  'use strict';

  var MAP = {
    'needoh': '/collections/needoh',
    'nee doh': '/collections/needoh',
    'youtooz': '/collections/youtooz',
    'pokemon': '/collections/pokemon',
    'pokémon': '/collections/pokemon',
    'star wars': '/collections/star-wars',
    'starwars': '/collections/star-wars',
    'marvel': '/collections/marvel',
    'loungefly': '/collections/loungefly',
    'fuggler': '/collections/fuggler',
    'hot toys': '/collections/hot-toys',
    'black series': '/collections/the-black-series',
    'action figures': '/collections/action-figures',
    'action figure': '/collections/action-figures',
    'advent calendar': '/collections/advent-calendars',
    'gifts under 10': '/collections/gifts-under-10'
  };

  function norm(s) {
    return (s || '').toLowerCase().trim().replace(/\s+/g, ' ');
  }

  function target(q) {
    return MAP[norm(q)] || null;
  }

  // 1) Intercept search submissions before they navigate to /search
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/search') === -1) return;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    var dest = target(input.value);
    if (dest) {
      e.preventDefault();
      window.location.href = dest;
    }
  }, true);

  // 2) Catch direct loads of /search?q=brand
  if (window.location.pathname.replace(/\/+$/, '') === '/search') {
    try {
      var q = new URLSearchParams(window.location.search).get('q');
      var dest = target(q);
      if (dest) window.location.replace(dest);
    } catch (e) {}
  }
})();
